var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChallengeLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 41,
    viewBox: "0 0 33 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "card-locked"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.6425 40.1102C3.59489 40.1102 2.69839 39.7375 1.953 38.9921C1.20634 38.2455 0.833008 37.3483 0.833008 36.3007V17.2533C0.833008 16.2056 1.20634 15.3085 1.953 14.5618C2.69839 13.8165 3.59489 13.4438 4.6425 13.4438H6.54725V9.63427C6.54725 6.99937 7.47613 4.75304 9.33389 2.89527C11.1904 1.03878 13.4361 0.110535 16.071 0.110535C18.7059 0.110535 20.9522 1.03878 22.81 2.89527C24.6665 4.75304 25.5947 6.99937 25.5947 9.63427V13.4438H27.4995C28.5471 13.4438 29.4442 13.8165 30.1909 14.5618C30.9363 15.3085 31.309 16.2056 31.309 17.2533V36.3007C31.309 37.3483 30.9363 38.2455 30.1909 38.9921C29.4442 39.7375 28.5471 40.1102 27.4995 40.1102H4.6425ZM16.071 30.5865C17.1186 30.5865 18.0157 30.2138 18.7624 29.4684C19.5078 28.7217 19.8805 27.8246 19.8805 26.777C19.8805 25.7294 19.5078 24.8322 18.7624 24.0856C18.0157 23.3402 17.1186 22.9675 16.071 22.9675C15.0234 22.9675 14.1269 23.3402 13.3815 24.0856C12.6348 24.8322 12.2615 25.7294 12.2615 26.777C12.2615 27.8246 12.6348 28.7217 13.3815 29.4684C14.1269 30.2138 15.0234 30.5865 16.071 30.5865ZM10.3567 13.4438H21.7852V9.63427C21.7852 8.04698 21.2297 6.69778 20.1186 5.58668C19.0075 4.47558 17.6583 3.92003 16.071 3.92003C14.4837 3.92003 13.1345 4.47558 12.0234 5.58668C10.9123 6.69778 10.3567 8.04698 10.3567 9.63427V13.4438Z",
    fill: "#FBD38D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChallengeLock);
export default __webpack_public_path__ + "static/media/ChallengeLock.0e516cbfc850d800fd81fa5be4f7a7d0.svg";
export { ForwardRef as ReactComponent };